import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  joinOperationResultSchema,
  type JoinOperationInput,
  type JoinOperationResult,
} from '@killer-party/contracts';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { PlayerSessionService } from './player-session.service';

@Injectable({ providedIn: 'root' })
export class EnrollmentService {
  private readonly http = inject(HttpClient);
  private readonly session = inject(PlayerSessionService);

  // POST /api/enroll, protege par Turnstile (TD-019). Le jeton joueur n'est remis
  // qu'une fois : il est garde aussitot, avec le nom de code saisi.
  async enroll(input: JoinOperationInput, turnstileToken: string): Promise<JoinOperationResult> {
    const response = await firstValueFrom(
      this.http.post<unknown>(`${environment.apiBaseUrl}/api/enroll`, input, {
        headers: { 'X-Turnstile-Token': turnstileToken },
      }),
    );
    const result = joinOperationResultSchema.parse(response);
    this.session.save({
      missionId: result.missionId,
      agentToken: result.agentToken,
      codeName: input.codeName,
    });
    return result;
  }
}
